import type { AttributeCondition, Spec } from './moving-item.types';

export function newRowKey(): string {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `row-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/** 행마다 새 키가 필요하므로 렌더 밖에서 호출마다 생성한다 */
export function makeEmptyCondition(): AttributeCondition {
  return {
    rule: { type: 'ALWAYS_MATCH' },
    effect: { type: 'GUIDE_MESSAGE' },
    _clientRowKey: newRowKey(),
  };
}

/** 키가 없는 행에만 새 키를 찍는다 (이미 있는 행의 신원은 유지) */
export function withRowKeys<T extends { _clientRowKey?: string }>(rows: T[] | undefined): T[] {
  return (rows ?? []).map((row) =>
    row._clientRowKey ? row : { ...row, _clientRowKey: newRowKey() }
  );
}

/**
 * 편집 초안의 모든 규칙 행에 클라이언트 키를 보장한다.
 *
 * 서버에서 온 행에는 `_clientRowKey` 가 없다. 키가 없으면 목록이 인덱스로 폴백해
 * (`ConditionRuleList.resolveRowKey`·`DisplayTemplateRuleList.resolveRowKey`), 다른 행을
 * 지우거나 평가 속성을 옮기는 순간 인덱스가 밀려 열려 있던 편집 패널이 엉뚱한 행에
 * 붙는다. 편집 시작 시 한 번 찍어두면 세션 내내 행 신원이 고정된다.
 * 저장 요청에서는 API 레이어가 이 필드를 걷어낸다.
 */
export function withDraftRowKeys(spec: Spec): Spec {
  return {
    ...spec,
    conditions: withRowKeys(spec.conditions),
    displayTemplateRules: withRowKeys(spec.displayTemplateRules),
    attributes: spec.attributes.map((attr) =>
      attr.conditions ? { ...attr, conditions: withRowKeys(attr.conditions) } : attr
    ),
  };
}
